<template>
    <div class="eventItem" :style="{
        'border-bottom': FreedomAppConfig.eventBottomBorderColor ? `2px solid ${FreedomAppConfig.eventBottomBorderColor}` : '',
    }">
      <div class="eventItem-type"><div class="eventItem-icon" :class="[getIcon(format)]"></div></div>
      <div class="eventItem-content">
        <div class="eventItem-format" :style="{color: FreedomAppConfig.eventFormatColor}" v-text="format"/>
        <div v-html="event.title" class="eventItem-title" @click="goToEvent" title="View"/>
        <div v-if="event.startTime" v-text="time" class="eventItem-date"/>
<!--        <p v-html="cleanDesc" class="eventItem-description"/>-->
        <div class="eventItem-tags">
            <div v-for="(tag, i) in eventTags"
                 :key="`tag_${i}`"
                 :class="[
                     'tag',
                      tag.toLowerCase() === FreedomAppConfig.eventFeaturedTag.toLowerCase() ? 'featured' : '',
                  ]"
            >
                <star class="featured-icon" v-if="tag.toLowerCase() === FreedomAppConfig.eventFeaturedTag.toLowerCase()"/>
                <span v-text="tag"/>
            </div>
        </div>
      </div>
      <div class="eventItem-action"> <div class="arrowLink" @click="goToEvent">{{readMoreTextComputed}}</div>      </div>
    </div>
</template>

<script>
import FreedomAppConfig from "../FreedomAppConfig";
import moment from 'moment';
import Lodash from "lodash";
import Star from "../assets/star";
export default {
    name: "event",
    components: {Star},
    props: {
        event: {type: Object, default: () => {}},
        activities: {type: Array, default: () => []},
        linkTemplate: {type: String, required: true},
        readMoreText: {type: String, required: false},
    },
    data: function() {
        return {
            FreedomAppConfig,
        };
    },
    computed: {
        readMoreTextComputed: function(){
          return this.readMoreText ? this.readMoreText : 'Read More';
        },
        time: function() {
             let time =  moment(`2020-01-01 ${this.event.startTime}`).format("h:mma") ;
             if(this.event.endTime !== '' && this.event.endTime !== null && this.event.endTime !== '00:00:00' && this.event.startDate === this.event.endDate){
               time +=  ' - ' + moment(`2020-01-01 ${this.event.endTime}`).format("h:mma")
             }
             if(this.event.startDate != this.event.endDate){
               var endTime = this.event.endTime || '00:00:00';
               time = moment(`${this.event.startDate} ${this.event.startTime}`).format("MMMM D @ h:mma") ;
               var end = moment(`${this.event.endDate} ${endTime}`);
               time +=  ' - ';
               if(this.event.endTime !== '' && this.event.endTime !== null && this.event.endTime !== '00:00:00' ){
                 time += end.format("MMMM D @ h:mma");
               } else {
                 time += end.format("MMMM D");
               }
             }
             return time;
        },
        format: function() {
            const arr = this.activities
                .filter(a => a['prefix'] === FreedomAppConfig['eventFormatPrefix'])
                .filter(a => this.event.tags.map(e => e.name.trim().toLowerCase()).includes(a['value'].toLowerCase()));
            return (arr.length && arr[0].value) ? arr[0].value : '';
        },
        link: function() {
            /** @type {TemplateExecutor} */
            const templateExec = Lodash.template(this.linkTemplate);
            return templateExec({id: this.event['id'], directory: this.event['directory']});
        },

        eventTags: function() {
            if (!this.event.tags) return [];
            let tags = this.event.tags.map(o => o.name);
            tags = tags.sort();

            // If eventFeaturedTag, move it to end of array to be shown last
            if (FreedomAppConfig.eventFeaturedTag) {
                if (tags.map(v => v.toLowerCase()).includes(FreedomAppConfig.eventFeaturedTag.toLowerCase())) {
                    tags = tags.filter(v => v.toLowerCase() !== FreedomAppConfig.eventFeaturedTag.toLowerCase());
                    tags.push(FreedomAppConfig.eventFeaturedTag);
                }
            }
            return tags;
        },
        cleanDesc: function(){
            var cleanedDesc =  this.event.description.replace(/(<([^>]+)>)/gi, "").substr(0,100)
            if(cleanedDesc){
              cleanedDesc += '...';
            }
            return cleanedDesc;
        }

    },
    methods: {
        goToEvent: function(e) {
          if (this.event.videoId) {
            this.$emit('popupDetail', this.event.videoId);
          } else {
            if (e.ctrlKey || e.metaKey) {
              window.open(this.link, '_blank');
            } else {
              window.location = this.link;
            }
          }
        },
        triggerPopup: function(){
          this.$emit('popup', this.link);
        },
        getIcon: function(value) {
          value = value.trim().replaceAll(' ', '_');
          return FreedomAppConfig[`icon_${value}`];
        }
    }
}
</script>
<style>

.eventItem-type::after {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  content: "";
  height: 80px;
  border: 0;
  border-left: 100px solid #35bed4;
  border-bottom: 80px solid transparent;
}
</style>
<style scoped>
.eventItem {
    display: flex;
    flex-flow: row wrap;
    margin: 20px 0 0 0;
    padding-bottom: 20px;
}

.tag {
    background-color: #e8e8e8;
    font-size: 12px;
    padding: 5px 15px;
    margin-right: 10px;
    cursor: default;
    display: flex;
    align-items: center;
}

.featured {
    background-color: unset !important;
    font-weight: 500;
    padding: 5px;
}

.featured-icon {
    color: #fcd155;
    height: 16px;
    margin: 0 5px 0 0;
}

.eventItem-format {
    font-weight: 600;
    text-transform: uppercase;
}

.eventItem-title {
    margin: 0 0 5px 0;
    cursor: pointer;
    font-weight: 700;
    font-size: 18px;
}

.eventItem-description {
    margin: 0 0 5px 0;
}

.eventItem-date {
    /*margin: 0 0 5px 0;*/
}

.eventItem-tags {
    display: flex;
    margin-top: 1rem;
}
.eventItem-content{
  display: flex;
  flex-flow: column;

}
.eventItem-icon {
  color: white;
  background: #313131;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  text-align: center;
  line-height: 45px;
  font-size: 20px;
  position: relative;
  z-index: 1;
}

.eventItem-type {
  position: relative;
  width: 100px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 2rem;
}
.eventItem-action {
  margin-left: auto;
  align-self: center;
  padding: 1rem 2rem 1rem 1rem;
}
</style>